import React from 'react';

const RetroBackground = () => {
  return (
    <div className="fixed inset-0 w-full h-full bg-indigo-900/30" style={{ zIndex: -10 }}>
      {/* Gradiente de fondo retro */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/40 to-purple-900/40"></div>
      
      {/* Cuadrícula retro */}
      <div className="absolute inset-0 opacity-30" 
        style={{
          backgroundImage: `
            linear-gradient(0deg, transparent 9%, rgba(218, 165, 32, 0.2) 10%, rgba(218, 165, 32, 0.2) 12%, transparent 13%, transparent),
            linear-gradient(90deg, transparent 9%, rgba(218, 165, 32, 0.2) 10%, rgba(218, 165, 32, 0.2) 12%, transparent 13%, transparent)
          `,
          backgroundSize: '80px 80px'
        }}
      />
      
      {/* Elementos decorativos retro */}
      <div className="absolute top-1/3 left-1/4 w-72 h-72 rounded-full bg-amber-500/10 blur-3xl"></div>
      <div className="absolute bottom-1/3 right-1/4 w-60 h-60 rounded-full bg-purple-500/10 blur-3xl"></div>
      
      {/* Sol retro */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[800px] h-[400px] bg-gradient-to-t from-amber-500/20 to-transparent rounded-t-full -mb-[200px] blur-xl"></div>
      
      {/* Líneas horizontales estilo montañas */}
      <div className="absolute bottom-1/4 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-500/50 to-transparent"></div>
      <div className="absolute bottom-1/3 left-0 right-0 h-px bg-gradient-to-r from-transparent via-purple-500/30 to-transparent"></div>
      
      {/* Estrellas aleatorias */}
      <div className="absolute inset-0">
        {Array.from({ length: 50 }).map((_, index) => {
          const top = `${Math.random() * 100}%`;
          const left = `${Math.random() * 100}%`;
          const size = `${Math.random() * 2 + 1}px`;
          const opacity = Math.random() * 0.7 + 0.3;
          
          return (
            <div
              key={index}
              className="absolute rounded-full bg-amber-200"
              style={{
                top,
                left,
                width: size,
                height: size,
                opacity
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RetroBackground; 